<div class="grid-x content content-with-elevation">
  <div class="cell large-10 small-12 medium-10 ">
    <div class="content-sub-header">{{techCheckResult.title}}</div>
    <div class="text-helper">{{techCheckResult.description}}</div>
    <a class="a-link" (click)="openResultDetails()" *ngIf="!showResultDetails">Click for more details ></a>
    <div *ngIf="showResultDetails" [innerHtml]="techCheckResult.html_details" style="margin-top: 16px">
    </div>
  </div>
  <div class="cell large-2 small-12 medium-2 result-border {{techCheckResult.result | techCheckCssHelper}}">
    {{techCheckResult.result }}
  </div>
</div>

